var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/twinfieldproduct/viewmodels/index',["require", "exports", "common/viewmodelbase", "models/portal", "services/navigator", "services/settings"], function (require, exports, Common, Portal, Navigator, Configuration) {
    "use strict";
    var TwinfieldProductViewModel = (function (_super) {
        __extends(TwinfieldProductViewModel, _super);
        function TwinfieldProductViewModel() {
            _super.call(this);
            this.breadCrumb = new Portal.ModuleBreadCrumbItemHolder();
            this.cdnEndPoint = Configuration.Settings.environment.getCustomValue("CdnEndPoint");
            this.testimonials = [];
            this.toolkitVideos = [];
            this.informationToSendToClient = [];
            this.initializeTestimonials();
            this.initializeInformationToSendToClient();
            this.title = "TwinfieldProduct";
            ko.track(this, ["tabSelected", "testimonials"]);
        }
        TwinfieldProductViewModel.prototype.onActivated = function (context) {
            this.tabSelected = 0;
            this.shopId = context.queryString.shopId;
            var parameter = context.path.split('/');
            var calledFromTools = parameter[1] != null ? JSON.parse(parameter[1]) : null;
            this.createTwinfieldCrumb();
            this.spliceLastBreadcrumbs(context, calledFromTools);
            this.getTwinfieldProductDetails();
            this.createTwinfieldProductDetailsCrumb();
        };
        TwinfieldProductViewModel.prototype.initializeTestimonials = function () {
            var testimonial1 = {
                image: this.cdnEndPoint + "content/images/KrestonReevesLogo.gif",
                name: "Emma Chesson FCCA, Head of Online Services, Kreston Reeves LLP",
                text: '“Twinfield stood out for flexibility… Businesses of any size will find it advantageous. For a large group of companies it can help bring their information together in a much more timely manner. For a start-up, with integrated management reporting it can help grow the business. We can provide a better service, be more interactive. Ultimately we’re becoming their virtual finance teams, a resource to help them grow.”',
                link: "",
                linkText: ""
            };
            var testimonial2 = {
                image: this.cdnEndPoint + "content/images/LibertyLeasingLogo.png",
                name: "Alan Cooper, Finance Director, Liberty Leasing Ltd (An FCA regulated asset finance company) ",
                text: '“…there were a lot of solutions for smaller businesses, and a lot of solutions for large and very large businesses, but for those of us in the SME space the smaller solutions didn’t really fit our requirements of having to grow into the future. The bigger solutions were too expensive. Twinfield was different to that. Twinfield was what we were looking for in that respect.  The online access was very important to us and was a key consideration to choosing a product…”',
                link: "https://www.youtube.com/watch?v=D0d2QgTzcHU",
                linkText: "Alan Cooper from Liberty Leasing Ltd explains why this rapidly expanding, FCA-regulated asset finance company chose Twinfield and what it's brought to the firm."
            };
            var testimonial3 = {
                image: this.cdnEndPoint + "content/images/dopayLogo.png",
                name: "Khaled Abou-Zied, Group Finance Director, dopay",
                text: "“Growing so fast, our accountancy needs are immediacy, high visibility of the accounts, the ability to consolidate the group accounting, and to be able to monitor results on a group basis for decision making … We were looking for a cloud based solution that enabled us to perform group consolidation and could be implemented across multiple countries.  We discussed our requirements with Goodman Jones, our accountants, and together we decided that Twinfield was the best solution.”",
                link: "https://www.youtube.com/watch?v=wSeH3SCVPJg",
                linkText: "Philip Woodgate of Goodman Jones and their client, Khaled Abou-Zied from Dopay, explain why and how Twinfield was the right choice for Dopay. "
            };
            var testimonial4 = {
                image: this.cdnEndPoint + "content/images/GoodmanLogo.jpg",
                name: "Philip Woodgate, Partner, Goodman Jones LLP",
                text: '"Twinfield delivers. As users for over ten years we’ve found it astonishingly reliable and adaptable. With Twinfield we have the tools to help our clients with more complex accounting requirements such as dual currency reporting and group consolidation."',
                link: "",
                linkText: ""
            };
            var testimonial5 = {
                image: this.cdnEndPoint + "content/images/agsLogo.jpg",
                name: "Steve Aston FCCA, Director, ags accountants and business advisors ltd",
                text: '"Our clients using Twinfield range from small businesses to those with over a £12 million turnover. Each individual client has different needs, some clients process their own invoices and we just view data remotely and for some others we process all paperwork. Sharing data in various ways has helped us as a practice increase efficiency whilst also alleviating the burden of record keeping felt by many of our clients. The integration of compliance and management accounting together is a huge advantage for businesses and helps us as accountants deliver key beneficial real time data to our clients."',
                link: "",
                linkText: ""
            };
            this.testimonials.push(testimonial1);
            this.testimonials.push(testimonial2);
            this.testimonials.push(testimonial3);
            this.testimonials.push(testimonial4);
            this.testimonials.push(testimonial5);
        };
        TwinfieldProductViewModel.prototype.initializeInformationToSendToClient = function () {
            var informationToSendToClient1 = {
                url: "https://ocuksbstatic.blob.core.windows.net/iserve/Twinfield-For-SMEs-Product-Sheet-OneClick-Version-1.pdf",
                text: "Twinfield For SME's Product Sheet OneClick Version",
                icon: "fa-file-text-o"
            };
            this.informationToSendToClient.push(informationToSendToClient1);
        };
        TwinfieldProductViewModel.prototype.createTwinfieldCrumb = function () {
            // initial add of Twinfield breadcrumb
            if (this.breadCrumb.items.length === 0) {
                this.addTwinfieldCrumbToBreadcrumbItems();
            }
        };
        TwinfieldProductViewModel.prototype.spliceLastBreadcrumbs = function (context, calledFromTools) {
            // calledFromTools - flag to see where TwinfieldProduct is called from (null - called from Dashboard, not null - called from Tools)
            if (this.breadCrumb.items.length > 1) {
                // for the Twinfield page in Tools
                if (calledFromTools == true) {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                }
                else {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 2, 2);
                }
            }
            else {
                // for the Twinfield page in Tools
                if (calledFromTools == true) {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                    this.addTwinfieldCrumbToBreadcrumbItems();
                }
                else {
                    this.breadCrumb.items.splice(this.breadCrumb.items.length - 1, 1);
                }
            }
        };
        TwinfieldProductViewModel.prototype.addTwinfieldCrumbToBreadcrumbItems = function () {
            var crumb = Portal.BreadCrumbItem.from("i-Serve");
            crumb.clickAction = function () { Navigator.navigateTo("iServe", "index", "/iServe", null); };
            this.breadCrumb.items.push(crumb);
        };
        TwinfieldProductViewModel.prototype.getTwinfieldProductDetails = function () {
            this.node = Portal.Context.shell.findNodeByUID(this.shopId);
        };
        TwinfieldProductViewModel.prototype.createTwinfieldProductDetailsCrumb = function () {
            var crumb = Portal.BreadCrumbItem.from(this.node.name);
            this.breadCrumb.items.push(crumb);
        };
        TwinfieldProductViewModel.prototype.selectTab = function (index) {
            this.tabSelected = index;
        };
        return TwinfieldProductViewModel;
    }(Common.ViewModelBase));
    var instance = new TwinfieldProductViewModel();
    return instance;
});

